<script setup lang="ts">
import { computed } from "vue";

import StringTooltip from "@/components/Tooltip/StringTooltip.vue";

import type { ScorePointData } from "@/models/Point";

withDefaults(defineProps<{
  negative: number;
  positive: number;
  type: "check" | "instance" | "record";
  connotation: ScorePointData["scoreConnotation"];
}>(), {  })

const SCC125_MAX = 5;

const messages = computed(() => [
  `This ${__props.type} is negatively impacting the score.`,
  `This ${__props.type} is mostly negatively impacting the score.`,
  `This ${__props.type} is somewhat negatively impacting the score.`,
  `This ${__props.type} is marginally negatively impacting the score.`,
  `This ${__props.type} is positively impacting the score.`,
]);

// Red ↦ Green
const colors = ["#0A0", "#6A0", "#FA0", "#A60", "#A00"];

const scc125Idx = computed(() => {
  const isNegative = __props.connotation === "negative";

  const value =
    __props.negative === 0 && __props.positive === 0 ? undefined : Math.floor((__props.positive / (__props.positive + __props.negative)) * (SCC125_MAX - 1));
  if (value == null) return;

  return {
    value,
    isNegative,
    message: messages.value[value],
    color: isNegative ? colors[value] : colors[4 - value],
  };
});
</script>

<template>
  <StringTooltip v-if="scc125Idx != null" :item="scc125Idx.message" #="{ item }">
    <div class="tw-flex tw-h-4 tw-items-end tw-justify-center tw-gap-px tw-py-1">
      <div
        v-for="(_, barIdx) in Array.from({ length: scc125Idx.value + 1 })"
        :key="barIdx"
        aria-hidden="true"
        class="tw-h-full tw-w-[3px] tw-brightness-75"
        :style="{ backgroundColor: scc125Idx.color }"
      />
      <p class="tw-sr-only">{{ item }}</p>
    </div>
  </StringTooltip>
</template>
